module.exports = __webpack_public_path__ + "static/img/cooperation01.230aa9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cooperation01.png
// module id = /oR8
// module chunks = 1